export enum NotificationStatusEnum {
     NONE = 0,
     TODO = 10,
     DONE = 20
}
